import { AGP_SITE } from './agp';
import { LMS_SITE } from './lms';
import { SOCIALPRENEUR_SITE } from './socialpreneur';
import type { SiteManifest } from './types';

export * from './types';
export * from './resolve';
export { AGP_SITE } from './agp';
export { LMS_SITE } from './lms';
export { SOCIALPRENEUR_SITE } from './socialpreneur';

/**
 * Every bespoke tenant site with an editable-content manifest. A NEW bespoke
 * site ships its manifest in the same PR as its `apps/member/src/tenants/<id>`
 * folder and adds one line here — the admin "Site Pages" tab then appears for
 * that tenant's build automatically (no API or editor work).
 */
export const SITE_MANIFESTS: Record<string, SiteManifest> = {
  agp: AGP_SITE,
  socialpreneur: SOCIALPRENEUR_SITE,
};

export function getSiteManifest(tenant: string | undefined | null): SiteManifest | undefined {
  return tenant ? SITE_MANIFESTS[tenant] : undefined;
}

/**
 * Manifests that are NOT tenant-specific: shipped to every tenant that has the
 * owning feature switched on, and edited on that feature's own admin page
 * rather than the bespoke-site "Site Pages" tab.
 *
 * Kept separate from `SITE_MANIFESTS` on purpose — that map is the per-tenant
 * lookup `getSiteManifest(VITE_TENANT)` walks, and a shared manifest in it would
 * show up as a bespoke site for a tenant of that name.
 */
export const SHARED_SITE_MANIFESTS: Record<string, SiteManifest> = {
  /** The learning pages. Gated on `lms_enabled`, edited at Learning → Learning Pages. */
  lms: LMS_SITE,
};
